export const emailValidator = (email) => {
  let regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  if (regex.test(email)) {
    return true;
  }
  return false;
};

export const passwordValidator = (password) => {
  let regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
  if (regex.test(password)) {
    return true;
  }
  return false;
};

export const eventFormValidator = (
  data,
  eventErrorFormData,
  setErrorEventFormData
) => {
  let error = false;
  let errorMessage = { ...eventErrorFormData };
  if (!data?.self_agency_approval) {
    if (data.agency === '' || data.agency.length === 0) {
      error = true;
      errorMessage['agency'] = 'Please select Agencies';
    }
    if (data.agency.length > 0 && data.agency.length < 3) {
      error = true;
      errorMessage['agency'] = 'Please select minimum 3 Agency';
    }
  }
    // if(data.is_premium === '' || data.is_premium === null || data.is_premium === undefined){
  //   error = true;
  //   errorMessage["is_premium"] = "Please select Premium Booking or Not";
  // }
  // if(data.quiz_id === ''){
  //   error = true;
  //   errorMessage["quiz_id"] = "Please select Quiz Id";
  // }
  if (data.business === "") {
    error = true;
    errorMessage["business"] = "Please enter Business Name";
  }
  if (data.coordinator_name === "") {
    error = true;
    errorMessage["coordinator_name"] = "Please enter Coordinator Name 1";
  }

  if (data.email_2 !== "" && !emailValidator(data.email_2)) {
    error = true;
    errorMessage["email_2"] = "Please enter valid Email ID 2";
  }

  if (data.phone_2 !== "" && data.phone_2.length !== 10) {
    error = true;
    errorMessage["phone_2"] = "Please enter 10 digit Contact Number 2";
  }


  if (data.email_3 !== "" && !emailValidator(data.email_3)) {
    error = true;
    errorMessage["email_3"] = "Please enter Email ID 3";
  }

  if (data.phone_3 !== "" && data.phone_3.length !== 10) {
    error = true;
    errorMessage["phone_3"] = "Please enter 10 digit Contact Number 3";
  }
  
  if (data.email === "") {
    error = true;
    errorMessage["email"] = "Please enter Email ID 1";
  }
  // if (!emailValidator(data.email)) {
  //   error = true;
  //   errorMessage["email"] = "Please enter valid Email ID";
  // }
  if (data.phone !== "" && data.phone.length !== 10) {
    error = true;
    errorMessage["phone"] = "Please enter 10 digit Contact Number 1";
  }
  if (data.event_name === "") {
    error = true;
    errorMessage["event_name"] = "Please enter Event Name";
  }
  if (data.from_date === "") {
    error = true;
    errorMessage["from_date"] = "Please enter Event From Date";
  }
  if (data.to_date === "") {
    error = true;
    errorMessage["to_date"] = "Please enter Event To Date";
  }

  setErrorEventFormData(errorMessage);
  return error;
};

export const miceFormValidator = (
  data,
  miceErrorFormData,
  setErrorMiceFormData
) => {
  let error = false;
  let errorMessage = { ...miceErrorFormData };

  if (data.additional_info.confernce_location === "") {
    error = true;
    errorMessage["confernce_location"] = "Please Select Conference Location";
  }
  if (data.additional_info.hotel_requirement === "") {
    error = true;
    errorMessage["hotel_requirement"] = "Please select Hotel Requirement";
  }
  if (!data?.self_agency_approval) {
    if (data.agency === '' || data.agency.length === 0) {
      error = true;
      errorMessage['agency'] = 'Please select Agencies';
    }
    if (data.agency.length > 0 && data.agency.length < 3) {
      error = true;
      errorMessage['agency'] = 'Please select minimum 3 Agencies';
    }
  }
  // if(data.is_premium === '' || data.is_premium === undefined || data.is_premium === null){
  //   error = true;
  //   errorMessage["is_premium"] = "Please select Premium Booking or Not";
  // }
  // if(data.quiz_id === ''){
  //   error = true;
  //   errorMessage["quiz_id"] = "Please select Quiz Id";
  // }
  if (data.business === "") {
    error = true;
    errorMessage["business"] = "Please enter Business Name";
  }
  if (data.coordinator_name === "") {
    error = true;
    errorMessage["coordinator_name"] = "Please enter Coordinator Name 1";
  }

  if (data.email_2 !== "" && !emailValidator(data.email_2)) {
    error = true;
    errorMessage["email_2"] = "Please enter Email ID 2";
  }

  if (data.phone_2 !== "" && data.phone_2.length !== 10) {
    error = true;
    errorMessage["phone_2"] = "Please enter 10 digit Contact Number 2";
  }

  if (data.email_3 !== "" && !emailValidator(data.email_3)) {
    error = true;
    errorMessage["email_3"] = "Please enter Email ID 3";
  }

  if (data.phone_3 !== "" && data.phone_3.length !== 10) {
    error = true;
    errorMessage["phone_3"] = "Please enter 10 digit Contact Number 3";
  }
  
  if (data.email === "") {
    error = true;
    errorMessage["email"] = "Please enter Email ID 1";
  }
  // if (!emailValidator(data.email)) {
  //   error = true;
  //   errorMessage["email"] = "Please enter valid Email ID";
  // }
  if (data.phone !== "" && data.phone.length !== 10) {
    error = true;
    errorMessage["phone"] = "Please enter 10 digit Contact Number 1";
  }
  if (
    data.additional_info.service_required === "" ||
    data.additional_info.service_required.length === 0
  ) {
    error = true;
    errorMessage["service_required"] = "Please select Service Type";
  }
  if (data.event_name === "") {
    error = true;
    errorMessage["event_name"] = "Please enter Event Name";
  }
  if (data.from_date === "") {
    error = true;
    errorMessage["from_date"] = "Please enter Event From Date";
  }
  if (data.to_date === "") {
    error = true;
    errorMessage["to_date"] = "Please enter Event To Date";
  }
  if (
    data.additional_info.hotel_requirement === "with_hotel" &&
    data.additional_info.number_of_nights === ""
  ) {
    error = true;
    errorMessage["number_of_nights"] = "Please enter Number of Nights";
  }

  setErrorMiceFormData(errorMessage);
  return error;
};
